import CreateAPaymentLinkModal, { CreateAPaymentLinkModalState } from '.';
import { jsx as _jsx } from "react/jsx-runtime";
const PostEnrollModal = props => {
  return /*#__PURE__*/_jsx(CreateAPaymentLinkModal, Object.assign({}, props, {
    modalState: CreateAPaymentLinkModalState.POST_ENROLL
  }));
};
export default PostEnrollModal;